import Button from '@mui/joy/Button';

export default function ButtonUsage() {
  return <Button variant="solid">Hello world</Button>;
}
